import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  formatCurrency as fmtCurrency,
  formatNumber as fmtNumber,
  formatPercent as fmtPercent,
  toBcp47,
} from './localeFormat';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// i18n_ — delegate to localeFormat.ts so all call sites get locale-aware
// output. Signature is preserved for backwards compatibility; the default
// locale still resolves to pl-PL when callers pass nothing.
export function formatCurrency(value: number, currency = 'PLN', locale = 'pl-PL') {
  return fmtCurrency(value, currency, toBcp47(locale));
}

export function formatNumber(value: number, locale = 'pl-PL') {
  return fmtNumber(value, toBcp47(locale));
}

export function formatPercent(value: number, locale = 'pl-PL') {
  return fmtPercent(value, toBcp47(locale));
}
